<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Actualizar contraseña:</h1>
      <p class="title-list">
        {{ selectedProfile?.username }} -
        {{ selectedProfile?.first_name }}
        {{ selectedProfile?.last_name }}
      </p>
    </div>
    <div class="form-body">
      <form [formGroup]="editPasswordForm" (ngSubmit)="updatePassword()">
        <div class="line">
          <div class="form-grid cols-1">
            <mat-form-field appearance="outline">
              <mat-label>Nueva contraseña</mat-label>
              <input
                type="password"
                minlength="4"
                matInput
                name="password"
                id="password"
                required
                formControlName="password"
              />
              @if (editPasswordForm.get('password')?.hasError('required')) {
                <mat-error class="for-text text-danger">Campo obligatorio</mat-error>
              }
              @if (editPasswordForm.get('password')?.hasError('minlength')) {
                <mat-error class="for-text text-danger"
                  >La contraseña debe tener mínimo 4 letras y/o números</mat-error
                >
              }
            </mat-form-field>
            <div class="password-mismatch-error-container">
              @if (showPasswordMatchError && editPasswordForm.errors?.['notSame']) {
                <small class="password-mismatch-error">
                  Las contraseñas no coinciden. Intentelo de nuevo
                </small>
              }
            </div>

            <mat-form-field appearance="outline">
              <mat-label>Confirmar contraseña</mat-label>
              <input
                type="password"
                minlength="4"
                matInput
                name="confirmPassword"
                id="confirmPassword"
                required
                formControlName="confirmPassword"
              />
              @if (editPasswordForm.get('confirmPassword')?.hasError('required')) {
                <mat-error class="for-text text-danger">Campo obligatorio</mat-error>
              }
              @if (editPasswordForm.get('confirmPassword')?.hasError('minlength')) {
                <mat-error class="for-text text-danger"
                  >La contraseña debe tener mínimo 4 letras y/o números</mat-error
                >
              }
            </mat-form-field>
            <div class="password-mismatch-error-container">
              @if (showPasswordMatchError && editPasswordForm.errors?.['notSame']) {
                <small class="password-mismatch-error">
                  Las contraseñas no coinciden. Intentelo de nuevo
                </small>
              }
            </div>
          </div>
        </div>
        <br />
        <button type="submit" class="primary-button" id="guardar">
          <span class="button-content"><mat-icon>save</mat-icon>Guardar</span>
        </button>
        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
